// store/slices/clientDataSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: {
    accountantId: null,
    caseId: null,
  },
  vatReport: null,
  advanceReportTax: {},
  reportTax: {},
  income: null,
  expense: null,
  equipment: null,
  zeroVatAmount: 0,
  sellEquipNoVat: 0,
  balances: 0,
  incomeTaxAdvances: 0,
  withholding: {
    payment: 0,
    accepted: 0
  },
  calculatedValues: {
    computed: {
      IncomeTaxAdvances: 0,
      AcceptedWithholdingTaxMaximum: 0,
      total: 0,
    },
    reported: {
      IncomeTaxAdvances: 0,
      AcceptedWithholdingTaxMaximum: 0,
      total: 0,
    },
  },

  closedMonths: {
    start: false,
    end: false
  },
  profitAmount: 0,
  netVatAmount: 0,
  incomesAmountDetailed: {
    amount17: 0,
    amount18: 0
  },
  incomeNoVat: 0,
  incomesVatAmount: 0,
  expensesVatAmount: 0,
  purchaseOfEquipmentExpensesVatAmount: 0,
  incomesAmount: 0,
  expensesAmount: 0,
  purchaseOfEquipmentExpensesAmount: 0,
  witholdingIncomesNoVat: 0,
  lastFetchedStartDate: null,
  lastFetchedEndDate: null,
  loading: false,
  error: null,
  equipmentVatDetailed: { vat: 0, vat17: 0, vat18: 0 },
  expensesVatDetailed: { vat: 0, vat17: 0, vat18: 0 },
  incomesVatDetailed: { vat: 0, vat17: 0, vat18: 0 },
  paymentWithholdingTax: 0,

  /** From GetVatAdvancesPageData (resolver); null until set or when reset by legacy fetch path */
  pageIncomeTaxAdvancePercentage: null,
  pageUseIncomeTaxAdvancePercentage: null,
  pageIncomeTaxAdvanceAmount: null,

  /**
   * Per-partner per-year resolved advance settings, keyed by partner Guid string.
   * Each value is { incomeTaxAdvancePercentage, useIncomeTaxAdvancePercentage, incomeTaxAdvanceAmount }.
   * Empty object for non-partnership clients or when the API doesn't return it (older server).
   */
  partnerAdvanceSettings: {},

};

const clientDataSlice = createSlice({
  name: 'clientData',
  initialState,
  reducers: {
    resetClientData: () => initialState,
    setAllClientData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        lastFetchedStartDate: action.payload.lastFetchedStartDate,
        lastFetchedEndDate: action.payload.lastFetchedEndDate,
        loading: false,
        error: null
      };
    },
    setClientLoading: (state, action) => {
      state.loading = action.payload;
    },
    setClientError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setVatReportData: (state, action) => {
      state.vatReport = action.payload;
    },
    setIncomeTaxAdvances: (state, action) => {
      state.incomeTaxAdvances = action.payload;
    },
    setWitholdingIncomesNoVat: (state, action) => {
      state.witholdingIncomesNoVat = action.payload;
    },
    setCalculatedValues(state, action) {
      state.calculatedValues = action.payload;
    },
    updateValue(state, action) {
      state.value = action.payload; // Handled immutably by Immer
    },
    setIncomeNoVat(state, action) {
      state.incomeNoVat = action.payload;
    },
    setAdvanceReportTax: (state, action) => {
      state.advanceReportTax = action.payload;
    },
    setReportTax: (state, action) => {
      state.reportTax = action.payload;
    }
  },
});

export const {
  resetClientData,
  setAllClientData,
  setClientLoading,
  setClientError,
  setVatReportData,
  setIncomeTaxAdvances,
  setWitholdingIncomesNoVat,
  setCalculatedValues,
  updateValue,
  setIncomeNoVat,
  setAdvanceReportTax,
  setReportTax
} = clientDataSlice.actions;

export default clientDataSlice.reducer;
